module.exports = __webpack_public_path__ + "img/good.63eeb41c.png";